



















import { login } from "../api/login";
import { Component, Vue, Prop } from "vue-property-decorator";
import { postgrest } from '../api/postgrest';

@Component({})
export default class Login extends Vue {
  public userList: string[] = [];
  public username: string = "";
  public password: string = "";

  public async authenticate(): Promise<void> {
    if (!this.$store.state.loggedIn) {
      try {
        const loginchunk = await login.getUser(
          this.username,
          this.password,
          this.$store.getters.getHost,
          this.$store.getters.getConnectionDuration
        );
        let resp = await loginchunk.json();
        this.$store.dispatch("AddUserName", resp.username);
        this.$store.dispatch("AddToken", resp.token);
        this.$store.dispatch("login");
        this.$store.dispatch("updateUserLevel", resp.level);
        this.$store.dispatch("updateCurrentComponent", "Welcome");
        this.$store.dispatch("setCurrentId", -1);
        this.$store.dispatch("resetTime");
        // kanei riset sti mia wra
        this.$router.replace({ name: "load" });

        try {
          console.log('Postgrest call')
          let res = await postgrest.get('companies', this.$store.getters.getToken);
          console.log('Postgrest result:' + JSON.stringify(res));
        } catch (ex) {
          console.log('Postgrest call exception:' + ex);
        }

        console.log("Userlevel:" + this.$store.state.userlevel);
      } catch (ex) {
        console.log("Failed logging in");
        return Promise.resolve();
      }
    } else {
      console.log("already logged");
    }
  }

  public async mounted() {
    await this.$store.dispatch("updateConnectionSettings");
    console.log("Login mounted()");
  }
}
